module.exports = __webpack_public_path__ + "assets/img/back-ea4801bd.png";